import { QuestionData, QuestionOption } from 'src/types/formQuestionnaire';

function localizeOption(
  option: QuestionOption,
  languageCode: string,
): QuestionOption {
  const translation = option.translations?.find(
    (t) => t.languageCode === languageCode,
  );
  const translatedText = translation?.optionText?.trim();
  if (!translatedText) return option;
  return { ...option, text: translatedText };
}

export function localizeQuestionDataForLocale(
  question: QuestionData,
  languageCode: string | null,
): QuestionData {
  if (!languageCode) return question;
  const translation = question.translations?.find(
    (t) => t.languageCode === languageCode,
  );
  const translatedQuestionText = translation?.questionText?.trim();
  const translatedDescription = translation?.description?.trim();

  const localizedOptions = question.options?.map((opt) =>
    localizeOption(opt, languageCode),
  );

  return {
    ...question,
    questionText: translatedQuestionText || question.questionText,
    description: translatedDescription
      ? translatedDescription
      : question.description,
    ...(localizedOptions !== undefined && { options: localizedOptions }),
  };
}
